import { Box, Skeleton, useTheme } from "@mui/material";

interface SkeletonLoaderProps {
  count: number;
  styles?: {
    height?: number;
    width?: number | string;
  };
}

const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({ count, styles }) => {
    const theme = useTheme();
            const isDarkMode = theme.palette.mode === "dark";
  return (
    <Box  style={{width: styles?.width || 'auto'}}>
      {[...Array(count)].map((_, index) => (
        <Skeleton
          key={index}
          variant="rectangular"
          animation="wave"
          height={styles?.height || 63}
          style={{
            marginBottom: "8px",
            borderRadius: "4px",
            backgroundColor: isDarkMode ? "#121212" : "rgb(239, 241, 246)", 
          }}
        />
      ))}
    </Box>
  );
};

export default SkeletonLoader;
